import React from 'react';
import {createRoot} from 'react-dom/client';
import CheckoutFooter from '@checkout/components/footer/CheckoutFooter.tsx';
import JshModule from '@core/scripts/helper/jsh-module';

const {moduleScope, config} = JshModule('checkout/checkout-footer');

const texts = {
    footerHeadlineCheckout: config.footerHeadlineCheckout,
    footerContactBoxCallUs: config.footerContactBoxCallUs,
    linkServicePhone: config.linkServicePhone,
    servicePhoneNumber: config.servicePhoneNumber,
    footerContactBoxMailUs: config.footerContactBoxMailUs,
    footerOpenContactForm: config.footerOpenContactForm,
    termsAndConditions: config.termsAndConditions,
    imprint: config.imprint,
    privacy: config.privacy,
    privacyCenter: config.privacyCenter,
    accessibility: config.accessibility,
    legalGuarantee: config.legalGuarantee,
    disclaimer: config.disclaimer,
    copyrightSign: config.copyrightSign,
    copyrightYearCompany: config.copyrightYearCompany,
    withdraw: config.withdraw,
};

createRoot(moduleScope).render(<CheckoutFooter texts={texts} staticLinks={config.staticLinks} />);
